import { render, staticRenderFns } from "./segmentosConfiguracoes.vue?vue&type=template&id=27e7620c&scoped=true&"
import script from "./segmentosConfiguracoes.vue?vue&type=script&lang=js&"
export * from "./segmentosConfiguracoes.vue?vue&type=script&lang=js&"
import style0 from "./segmentosConfiguracoes.vue?vue&type=style&index=0&id=27e7620c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e7620c",
  null
  
)

export default component.exports